import "@/App.css";
import { useEffect, useState } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import SilverInitiative from "@/pages/SilverInitiative";
import AudienceWorkspace from "@/pages/AudienceWorkspace";
import AdminLogin from "@/pages/AdminLogin";
import AdminEnquiries from "@/pages/AdminEnquiries";
import Insights from "@/pages/Insights";
import AnalyticsTracker from "@/components/analytics/AnalyticsTracker";
import ConsentBanner from "@/components/analytics/ConsentBanner";
import { getConsent, resetConsent } from "@/lib/analytics";
import { AuthProvider } from "@/context/AuthContext";

function Admin({ children }) {
  return <AuthProvider>{children}</AuthProvider>;
}

function App() {
  const [consent, setConsentState] = useState(getConsent());
  useEffect(() => {
    const reopen = () => { resetConsent(); setConsentState(null); };
    window.addEventListener("nc-consent-reset", reopen);
    return () => window.removeEventListener("nc-consent-reset", reopen);
  }, []);
  return (
    <div className="App">
      <TooltipProvider>
        <BrowserRouter>
          <AnalyticsTracker consent={consent} />
          <ConsentBanner consent={consent} onChange={setConsentState} />
          <Routes>
            <Route path="/" element={<SilverInitiative />} />
            <Route path="/audience" element={<AudienceWorkspace />} />
            <Route path="/insights" element={<Insights />} />
            <Route path="/admin/login" element={<Admin><AdminLogin /></Admin>} />
            <Route path="/admin" element={<Admin><AdminEnquiries /></Admin>} />
          </Routes>
        </BrowserRouter>
        <Toaster theme="dark" position="bottom-right" toastOptions={{ style: { background: "#0E2412", border: "1px solid rgba(255,255,255,0.1)", color: "#fff" } }} />
      </TooltipProvider>
    </div>
  );
}

export default App;
